module.exports = __webpack_public_path__ + "static/img/微生物测序.60c9849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/微生物测序.jpg
// module id = Bo6x
// module chunks = 1